import { operatorActionTypes } from './operator.types';

const INITIAL_STATE = {
    operator: []
};

const operatorReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case operatorActionTypes.SET_NEW_OPERATOR:
            return {
                ...state,
                operator: action.payload
            };
        default:
            return state;
    }
};

export default operatorReducer;